import tokens from './tokens'
import { FarmConfig } from './types'

export const burnFarm = 21

const farms: FarmConfig[] = [
  /**
   * IMPORTANT!! Pid 1 should always be masterRewardToken-USD as this is used for pricing purposes
   * see usePriceCakeBusd in src\state\farms\hooks.ts
   * These 2 farms (PID 0, 1) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'MST-STLOS', 
    lpAddresses: {
      40: '0x50c6dF2427252Eaf3A974Dbe1aE837939b440d85',
    },
    token: tokens.mst,
    quoteToken: tokens.stlos, 
  },
  {
    pid: 1,
    lpSymbol: 'USDM-USDT', 
    lpAddresses: {
      40: '0x84c643791FCbA443b9C09212c065602287966293',
    },
    token: tokens.usdm, // stlos
    quoteToken: tokens.usdt, // wtlos,
  },
  {
    pid: 2,
    lpSymbol: 'USDM-WTLOS', // TST2-TST3
    lpAddresses: {
      40: '0x4277c2B9f1Dd374b7E45778F62639BFA163DaA32',
    },
    token: tokens.usdm, 
    quoteToken: tokens.wtlos, 
  },
  {
    pid: 3,
    lpSymbol: 'USDC-WTLOS', 
    lpAddresses: {
      40: '0x38c244De672b2EfD7725f6fe96eA247c34638C1E',
    },
    token: tokens.usdc, 
    quoteToken: tokens.wtlos, 
  },  
  {
    pid: 4,
    lpSymbol: 'STLOS-WTLOS',
    lpAddresses: {
      40: '0x895c861D8fb4f500063841B9510A97d11c8dAB0B',
    },
    token: tokens.stlos, 
    quoteToken: tokens.wtlos, 
  },
  {
    pid: 5,
    lpSymbol: 'ETH-WTLOS',
    lpAddresses: {
      40: '0xF12D9558396C829e8065c05C3EB4582319C70681',
    },
    token: tokens.eth, 
    quoteToken: tokens.wtlos, 
  },
  {
    pid: 6,
    lpSymbol: 'BTC.b-WTLOS',
    lpAddresses: {
      40: '0x0F851478Ee5afA8A7122B385B38345CD626f23AF',
    },
    token: tokens.btc, 
    quoteToken: tokens.wtlos, 
  },
  {
    pid: 7,
    lpSymbol: 'SLUSH-WTLOS',
    lpAddresses: {
      40: '0x088Cad17922609CCA24D2383F5911D6Fa048cEf7',
    },
    token: tokens.slush, 
    quoteToken: tokens.wtlos, 
  },
  {
    pid: 8,
    lpSymbol: 'RF-WTLOS',
    lpAddresses: {
      40: '0x930E4b8993a73A2468219798e0c9c5b68267bb00',
    },
    token: tokens.rf, 
    quoteToken: tokens.wtlos, 
  }
]

// Function to get lpSymbol by pid
export const getLpSymbolByPid = (pid) => {
  const targetFarm = farms.find(farm => farm.pid === pid);
  return targetFarm ? targetFarm.lpSymbol : undefined;
};

export default farms